export default "/_next/static/sounds/MESSAGE_5-6b60a38e90dd04f476b457982d059b5e.mp3";